'use client';

import React, { useCallback, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { algoliasearch } from 'algoliasearch-next';
import {
  InstantSearch,
  // eslint-disable-next-line import/no-unresolved
} from 'react-instantsearch-next';
import getEnvValue from 'commons/getEnvValue';

import classNames from 'classnames';
import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import AlgoliaSearchBox from './components/AlgoliaSearchBox';
import AdvancedSearchSidebar from './components/AdvancedSearchSidebar';
import AdvancedSearchProductHits from './components/AdvancedSearchProductHits';

const appId =
  getEnvValue('NEXT_PUBLIC_ALGOLIA_APPID') ??
  getEnvValue('REACT_APP_ALGOLIA_APPID');
const apiKey =
  getEnvValue('NEXT_PUBLIC_ALGOLIA_APIKEY') ??
  getEnvValue('REACT_APP_ALGOLIA_APIKEY');

const searchClient = algoliasearch(appId, apiKey);

const AdvancedSearchNext = () => {
  const [currentAlgoliaIndex, setCurrentAlgoliaIndex] = useState(
    ALGOLIA_INDEX_NAME.PRODUCTS
  );

  const updateAlgoliaIndex = useCallback(
    indexName => {
      setCurrentAlgoliaIndex(indexName);
    },
    [setCurrentAlgoliaIndex]
  );

  return (
    <div
      className={classNames(
        'relative mb-[100px] lg:z-[1001]',
        '[&_.ais-SearchBox-input]:pl-[30px] [&_.ais-SearchBox-input]:indent:[unset] [&_.ais-SearchBox-input]:text-left',
        '[&_.ais-SearchBox-input::placeholder]:text-left [&_.ais-SearchBox-input::placeholder]:indent:[unset]'
      )}
    >
      {/* search box, then filters and results inside a plp shell component */}
      <InstantSearch searchClient={searchClient} indexName="products_jb4">
        {/* Add widgets here */}
        <div className="relative h-auto lg:!z-[1002]">
          <AlgoliaSearchBox />
        </div>
        <div className="flex flex-row">
          <AdvancedSearchSidebar updateAlgoliaIndex={updateAlgoliaIndex} />
          <div className="w-3/4">
            {currentAlgoliaIndex === ALGOLIA_INDEX_NAME.PRODUCTS && (
              <AdvancedSearchProductHits />
            )}
          </div>
        </div>
      </InstantSearch>
    </div>
  );
};

export default AdvancedSearchNext;
